// extracted by mini-css-extract-plugin
export default {"Recipient":"Recipient_Recipient__ifVWV"};